const Search = function () 
{

    const toggleSideSearch = function (el)
    {
        //hide menu
        $("#wrap-sandwitch").toggle();

        el.toggleClass('motion-in');
        $("#side-search").toggleClass('motion-in');
    }

    return {
        init: function () {

            $("#call-search").on("click", function() {
                toggleSideSearch($(this));
            });
        }
    }

}();

module.exports = Search;